import { render, staticRenderFns } from "./HomeSociety.vue?vue&type=template&id=bb83553a&scoped=true&"
import script from "./HomeSociety.vue?vue&type=script&lang=js&"
export * from "./HomeSociety.vue?vue&type=script&lang=js&"
import style0 from "./HomeSociety.vue?vue&type=style&index=0&id=bb83553a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb83553a",
  null
  
)

export default component.exports